<template>
<div id="app_container">
    <!-- toolbar -->
    <v-app-bar app dense flat fixed clipped-left color="primary">
        <v-toolbar-title class="major white--text">
            <v-icon @click="drawer = !drawer" color="white" class="px-2">verified_user</v-icon>
            Master
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <im-app-selector />
        <im-profile />
    </v-app-bar>
    <!-- ./ toolbar -->

    <!-- navigation-drawer -->
    <v-navigation-drawer class="im-nav" fixed :clipped="true" app v-model="drawer">
        <v-list>
            <v-list-item :to="{path: '/users'}">
                <v-list-item-action>
                    <v-icon>people</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Users</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{path: '/organizations'}">
                <v-list-item-action>
                    <v-icon>business</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Organizations</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{path: '/services'}">
                <v-list-item-action>
                    <v-icon>work</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Services</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{path: '/events'}">
                <v-list-item-action>
                    <v-icon>fiber_smart_record</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Events</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{path: '/listeners'}">
                <v-list-item-action>
                    <v-icon>hearing</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Listeners</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
    <!-- ./ navigation-drawer -->

    <!-- content -->
    <v-content :class="{app_content_desktop: $vuetify.breakpoint.mdAndUp, app_content_phone: $vuetify.breakpoint.smAndDown}">
        <v-fade-transition mode="out-in">
            <router-view class="im-container" :key="$route.fullPath" />
        </v-fade-transition>
    </v-content>
    <!-- ./ content -->
</div>
</template>

<script>
import IMAppSelector from '@imemento/spa-helpers/src/components/IMAppSelector/IMAppSelector.vue';
import IMProfile from '@imemento/spa-helpers/src/components/IMProfile/IMProfile.vue';

export default {
    components: {
        'im-app-selector': IMAppSelector,
        'im-profile': IMProfile
    },

    data() {
        return {
            drawer: false
        }
    }
}
</script>
